module.exports = __webpack_public_path__ + "static/img/thumb_13.5756c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_13.png
// module id = qC0v
// module chunks = 0